import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseInputFieldComponent } from '../base/base-input-field.component';
import { SelectOption } from './select-field.properties';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'shared-ui-inputs-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectFieldComponent extends BaseInputFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(NgSelectComponent) ngSelectComponent?: NgSelectComponent;

  @Input() options = new Array<SelectOption>();
  @Input() multiple = false;
  @Input() resettable = true;
  @Input() filter = false;
  @Input() placeholder = '';
  @Input() setDefaultValue = true;

  private ngUnsubscribe = new Subject<void>();

  constructor(public cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    if (!this.options.find((x) => x.value === this.control.value) && this.options.length > 0 && this.setDefaultValue) {
      this.control.setValue(this.options[0].value);
    }

    this.control.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      this.selectLabelWhenValueIsNull(x);
    });
  }

  ngAfterViewInit(): void {
    this.selectLabelWhenValueIsNull(this.control.value);
  }

  selectLabelWhenValueIsNull(controlValue: unknown): void {
    if (controlValue === null && this.ngSelectComponent?.itemsList) {
      const nullItem = this.ngSelectComponent.itemsList.findItem(null);
      if (nullItem) {
        this.ngSelectComponent.select(nullItem);
        this.cdr.detectChanges();
      }
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
